.header {
  display: flex;
  align-items: center;
  padding: 22px 28px;
  border-bottom: 1px solid rgb(0 0 0 / 12%);
}

.main {
  display: grid;
  max-width: 382px;
  padding-inline: 12px;
  margin-inline: auto;
  margin-top: 200px;
}

.heading {
  padding-bottom: 12px;
  font-size: 21px;
  font-weight: 600;
  text-align: center;
}

.description {
  padding-bottom: 32px;
  font-size: 15px;
  font-weight: 300;
}

.form {
  display: grid;
  gap: 24px;
}

.input {
  padding: 12px 16px;
  font-size: 15px;
  font-weight: 300;
  border: 1px solid rgb(0 0 0 / 20%);
  border-radius: 8px;

  &::placeholder {
    color: rgb(0 0 0 / 60%);
  }
}

.button {
  padding: 10px 16px;
  color: var(--color-white);
  background-color: #000;
  border-radius: 8px;

  &:hover {
    background-color: rgb(77 77 77);
  }
}

.errorText {
  margin-top: -16px;
  font-size: 13px;
  color: #e6160f;
}
